import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  padding-top: 8px;
  padding-left: 0px;
  padding-right: 20px;
  padding-bottom: 8px;
  background-color: #28aee6;
  border-bottom: 1px solid grey;
`;
